// Pricing operators enter and review SAST even when their browser uses another timezone.
// The API continues to store UTC instants. South Africa uses UTC+02:00 year-round.
const formatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

const parts = (date: Date): Record<string, string> =>
  Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));

export function toSouthAfricanDateTimeInputValue(instant: string): string {
  const date = new Date(instant);
  if (Number.isNaN(date.getTime())) return '';
  const p = parts(date);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

export const fromSouthAfricanDateTimeInputValue = (value: string): string | null =>
  value ? new Date(`${value}+02:00`).toISOString() : null;

export function formatSouthAfricanDateTime(instant: string): string {
  const date = new Date(instant);
  if (Number.isNaN(date.getTime())) return 'Invalid date';
  const p = parts(date);
  return `${p.year}/${p.month}/${p.day}, ${p.hour}:${p.minute}:${p.second} SAST`;
}
